import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';

import { PaymentComponent } from './payment/payment.component';
import { PaymentListComponent } from './paymentlist/payment-list.component';
import { SyncCitcoComponent } from './synccitco/sync-citco.component';

import { PaymentModel } from 'app/shared/models/payment.model';

import { PaymentService } from './payment.service';

@Component({
    selector: 'app-payments',
    templateUrl: './payments.component.html',
    providers: [PaymentService]
})
/**
 * Component to display the payment management view.
 */
export class PaymentsComponent implements OnInit {
    dialogRef: MdDialogRef<any>;
    selectedData: Object;
    transactionStatus: ApplicationValue[];

    showCitcoButtons = environment.showCitcoButtons; // @todo tenant specific.

    @ViewChild('pendingPayments') pendingPaymentsList: PaymentListComponent;
    @ViewChild('otherPayments') otherPaymentsList: PaymentListComponent;

    constructor(
        private dialog: MdDialog,
        private viewContainerRef: ViewContainerRef,
        private paymentService: PaymentService,
        private warmUpService: WarmUpService,
        private snackBarService: SnackBarService
    ) { }

    loadTransactionStatus(transactionStatusValues: any) {
        if (transactionStatusValues instanceof Observable) {
            transactionStatusValues.subscribe(
                response => {
                    this.warmUpService.setApplicationTypeInLS(response);
                    this.transactionStatus = response.values;
                }
            );
        } else {
            this.transactionStatus = transactionStatusValues;
        }
    }

    ngOnInit() {
        this.loadTransactionStatus(
            this.warmUpService.getApplicationValue(ApplicationTypeConstants.TRANSACTION_STATUS));

        this.updatePaymentLists()

        this.paymentService.updatePaymentsListsEmitter.subscribe(
            (res) => {
                this.updatePaymentLists();
            }
        );
    }

    openPaymentDetailsDialog() {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(PaymentComponent, config);
        this.dialogRef.componentInstance.action = 'Add';
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                this.updatePaymentLists();
            }
        });
    }

    openSyncCitcoTransactionsDialog() {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(SyncCitcoComponent, config);

        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                this.updatePaymentLists();
            }
        });
    }

    updatePaymentLists() {
        this.pendingPaymentsList.updatePaymentList(PaymentStatus.PENDING);
        this.otherPaymentsList.updatePaymentList(PaymentStatus.OTHER);
    }
}

export enum PaymentStatus {
    // APPROVED = <any>'approved',
    // OUTSTANDING = <any>'outstanding',
    PENDING = <any>'pending',
    OTHER = <any>'other'
}


// WEBPACK FOOTER //
// ./src/app/finance/payments/payments.component.ts